import crossFetch from 'cross-fetch';
import { HealthServiceApi } from './HealthServiceApi';
import { ResponseError } from '@backstage/errors';
import {
  HealthServiceApiResponse,
  healthServiceApiResponseSchema,
} from '../types';

// these are isomorphic types that don't require @backstage/core-plugin-api
type ConfigApi = { getString(key: string): string };
type FetchApi = { fetch: typeof fetch };

export class HealthServiceClient implements HealthServiceApi {
  private readonly configApi: ConfigApi;
  private readonly fetchApi: FetchApi;

  public constructor(deps: { configApi: ConfigApi; fetchApi?: FetchApi }) {
    const { configApi, fetchApi } = deps;
    this.configApi = configApi;
    this.fetchApi = fetchApi ?? { fetch: crossFetch };
  }

  public async getLiveness(): Promise<HealthServiceApiResponse> {
    return this.getResponse('liveness');
  }

  public async getReadiness(): Promise<HealthServiceApiResponse> {
    return this.getResponse('readiness');
  }

  private async getResponse(endpoint: string) {
    const baseUrl = this.configApi.getString('backend.baseUrl');
    const response = await this.fetchApi.fetch(
      `${baseUrl}/.backstage/health/v1/${endpoint}`,
    );
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    const data = await response.json();
    return healthServiceApiResponseSchema.parse(data);
  }
}
